import React, { useState, useRef } from 'react';
import style from './index.module.less';
import UploloadFaceNew from '@/components/Content-Monitoring/Cpns/UploadFaceNew';
import AgreeSearch from '@/components/Content-Monitoring/Cpns/AgreeSearch';
import TermsOfUseModel from '@/components/Content-Monitoring/Cpns/TermsOfUseModel';

interface Props {
  isSearching: boolean;
  // eslint-disable-next-line
  onSearchClick: (imageUrl: string) => void;
  imageSearchUrl: string;
  // eslint-disable-next-line
  setImageSearchUrl: (url: string) => void;
  // eslint-disable-next-line
  onRegisterRemoveImage: (fn: () => void) => void;
  reverseSearchTitle: string;
  reverseSearchTitleFontSize: string;
  isAgreePrivacy: boolean;
  // eslint-disable-next-line
  setIsAgreePrivacy: (value: boolean) => void;
  isInHomePage?: boolean;
}

export default function ReverseSearch({
  isSearching,
  onSearchClick,
  imageSearchUrl,
  setImageSearchUrl,
  onRegisterRemoveImage,
  reverseSearchTitle,
  reverseSearchTitleFontSize,
  isAgreePrivacy,
  setIsAgreePrivacy,
  isInHomePage = false,
}: Props) {
  const [isShowTermsOfUseModel, setIsShowTermsOfUseModel] = useState(false);
  const [isFromSearchButton, setIsFromSearchButton] = useState(false);
  const [pendingSearchImageUrl, setPendingSearchImageUrl] = useState<string>('');
  const removeImageFnRef = useRef<(() => void) | null>(null);

  return (
    <div className={style.container}>
      <UploloadFaceNew
        isSearching={isSearching}
        isAgreePrivacy={isAgreePrivacy}
        setIsShowTermsOfUseModel={(isShow: boolean, pendingImageUrl?: string) => {
          setIsShowTermsOfUseModel(isShow);
          setIsFromSearchButton(isShow);
          setPendingSearchImageUrl(pendingImageUrl || '');
        }}
        onSearchClick={onSearchClick}
        title={reverseSearchTitle}
        subtitle={``}
        imageUrl="https://res-front.pumpsoul.com/prod-erasa/image/content-monitoring/uploadImg3.webp"
        imageSearchUrl={imageSearchUrl}
        setImageSearchUrl={setImageSearchUrl}
        setIsAgreePrivacy={setIsAgreePrivacy}
        type="photo"
        isShowBackgroundColor={false}
        onRegisterRemoveImage={(fn: () => void) => {
          removeImageFnRef.current = fn;
          onRegisterRemoveImage(fn);
        }}
        reverseSearchTitleFontSize={reverseSearchTitleFontSize}
        isInHomePage={isInHomePage}
      />
      <AgreeSearch
        isAgreePrivacy={isAgreePrivacy}
        setIsAgreePrivacy={setIsAgreePrivacy}
        setIsShowTermsOfUseModel={setIsShowTermsOfUseModel}
        isInDashboard={true}
      />

      {isShowTermsOfUseModel && (
        <TermsOfUseModel
          setIsShowTermsOfUseModel={setIsShowTermsOfUseModel}
          onAgree={() => {
            setIsAgreePrivacy(true);
            setIsShowTermsOfUseModel(false);
            if (isFromSearchButton && pendingSearchImageUrl) {
              setImageSearchUrl(pendingSearchImageUrl);
              onSearchClick(pendingSearchImageUrl);
            }
            setIsFromSearchButton(false);
            setPendingSearchImageUrl('');
          }}
        />
      )}
    </div>
  );
}
